module.exports = __webpack_public_path__ + "img/success.b052a4be.svg";